module.exports = __webpack_public_path__ + "img/forte5.539986dd.jpeg";